import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { textLink } from '../../../styled/mixins';
import routes from '../../../utils/constants/routes';
import mediaQueries from '../../../utils/mediaQueries';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  margin-bottom: 36px;
  @media ${mediaQueries.mdUp} {
    margin-bottom: 28px;
  }
`;

const Text = styled.p`
  color: ${({ theme }) => (theme.colors.chartGray)};
  margin: 0 5px 0 0;
`;

const TextLink = styled(Link)`
  ${textLink}
`;

const SignUpBox = () => (
  <Container>
    <Text>
      <FormattedMessage
        id="login.createAccount.text"
        defaultMessage="Don't have an account yet?"
      />
    </Text>
    <TextLink to={routes.CREATE_ACCOUNT}>
      <FormattedMessage
        id="login.signup.link"
        defaultMessage="Sign up"
      />
    </TextLink>
  </Container>
);

export default SignUpBox;
